/**
 * 수주 취소 방법 선택 창 (일지 카드 > 수주 취소)
 *
 * 구 Diary/Main.js 의 전역 selectOrderToCancel_ask() 이관.
 * 현장에서 장갑 끼고 보는 화면이라 문장을 읽게 하지 않는다 — 고를 것 두 개와 그 대가만 세워 두고,
 * 고르면 그 자리에서 **금액 표**가 펼쳐진다(공용 Dialog 의 choices 아코디언).
 * 확인 버튼 문구도 고른 말로 바뀌므로 창을 한 번 더 띄우지 않는다 — 선택창과 확인창이 한 창이다.
 *
 * 두 방법은 어플발주(order_type=0)에서만 함께 나온다. 그 외에는 고를 것이 하나뿐이라
 * 선택창을 건너뛰고 바로 확인창으로 간다.
 *
 * [호출]
 *   $j.F.Diary.CancelChoice.open(ordernum, orderType)   // window.selectOrderToCancel_ask 브리지가 부른다
 *
 * 실행은 Diary/Main.js 의 전역 — ask_cancelorder_run() / panalty_cancelorder_run().
 * (이름에 _run 이 붙은 쪽은 확인창 없이 바로 실행한다. 확인은 이 창이 이미 받았다)
 */
export default class CancelChoice {

    /** 페널티취소 수수료율 — 오더의 soo_fee_rate 와 무관하게 고정이다 (CashService::calcOrderFee, fee_status 5) */
    static PENALTY_RATE = 0.1;

    /** @param {number} ordernum  @param {number|string} orderType 오더 종류(0=어플발주) */
    open(ordernum, orderType) {
        // 어플발주가 아니면 '페널티 취소' 자체가 없다 → 고를 것이 없으니 확인창으로 직행
        if (String(orderType) !== '0') {
            window.ask_cancelorder_check(ordernum);
            return;
        }

        $j.Ui.Dialog.open({
            tone:    'danger',                               // 배차된 오더를 무르는 자리다 — 경고 배지를 단다
            title:   '수주 취소',
            emph:    '반드시 발주자와 통화하세요',   // 두 방법에 공통이라 한 번만 적는다
            confirm: '방법을 고르세요',                      // 고르기 전 — 버튼은 잠겨 있다
            cancel:  '닫기',
            choices: [
                {
                    label:   '발주자에게 요청',
                    tag:     '페널티 없음',
                    tone:    'good',
                    rows:    [{ k: '페널티',    v: '없음' },
                              { k: '수주포인트', v: '차감 없음' }],
                    confirm: '취소 요청',
                    onPick:  () => window.ask_cancelorder_run(ordernum),
                },
                {
                    label:   '내가 바로 취소',
                    tag:     '대금 10% · 200점 차감',
                    tone:    'bad',
                    rows:    this.penaltyRows(),
                    confirm: '바로 취소',
                    onPick:  () => window.panalty_cancelorder_run(ordernum),
                },
            ],
        });
    }

    /**
     * 페널티취소로 내가 무는 것.
     * 장비대금을 알면 금액으로, 모르면 비율로 적는다 — 틀린 숫자를 보여주느니 비율이 낫다.
     */
    penaltyRows() {
        const price = Number(window.ORDER?.car_price || 0);
        const fee   = Math.floor(price * CancelChoice.PENALTY_RATE);
        const rows  = [];

        if (price > 0) {
            rows.push({ k: '페널티 (10%)', v: `-${fee.toLocaleString()}원`, tone: 'danger' });
        } else {
            rows.push({ k: '페널티', v: '장비대금의 10%', tone: 'danger' });
        }
        rows.push({ k: '수주포인트', v: '200점 차감', tone: 'danger' });
        rows.push({ k: '오더', v: '자동 재발주' });   // 취소 뒤 큐가 다시 발주한다 (Diary/Main.js panalty_cancelorder_run 안내와 같은 내용)
        return rows;
    }
}
